import React, { useEffect } from "react";
import { useLogout } from "shared/api";
import Router from "next/router";
import pages from "pages/_router";

const LogoutPage = () => {
  const logout = useLogout();

  useEffect(() => {
    logout();
    Router.replace(pages.login.href);
  });

  return null;
};

export default LogoutPage;
